import { useQuery } from "@tanstack/react-query";
import { getOrganization } from "auth/services";

export const useOrganization = ({
    accessToken,
    orgId,
}: {
    accessToken?: string;
    orgId?: string;
}) => {
    const { data, isLoading } = useQuery({
        queryKey: ["organization", accessToken, orgId],
        queryFn: () => getOrganization({ accessToken, orgId }),
        enabled: !!accessToken && !!orgId,
    });

    return { organization: data, isLoading };
};
